import type { PriceVarianceFilters } from "../api/reports";

export function priceVarianceHref(filters: PriceVarianceFilters = {}): string {
  const params = new URLSearchParams();
  appendValues(params, "article", filters.article);
  appendValues(params, "project", filters.project);
  appendValues(params, "delivery_address_key", filters.delivery_address_key);
  appendValues(params, "manufacturer_id", filters.manufacturer_id);
  appendValues(params, "supplier", filters.supplier);
  if (filters.price_anomaly_status) {
    params.set("price_anomaly_status", filters.price_anomaly_status);
  }
  if (filters.online_user) params.set("online_user", filters.online_user);
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  if (filters.min_delta_pct != null) {
    params.set("min_delta_pct", String(filters.min_delta_pct));
  }
  if (filters.is_warehouse != null) {
    params.set("is_warehouse", filters.is_warehouse ? "true" : "false");
  }
  const query = params.toString();
  return query ? `/reports/variance?${query}` : "/reports/variance";
}

function appendValues(
  params: URLSearchParams,
  key: string,
  values: readonly string[] | undefined,
) {
  for (const value of values ?? []) {
    if (value) params.append(key, value);
  }
}
